import './Logo.css';
import LogoComponent from "../../../../generalComponents/logoComponent/LogoComponent";

const Logo = () => {
    return (
        <LogoComponent className="login" />
    );
};

export default Logo;